import { orderBy } from 'firebase/firestore';

import { lifescanConverter } from './converters/lifescan';
import {
  CollectionOptions,
  getAuthentication,
  getCollection,
  query,
  where,
} from './helpers';

export const getLifescans = async () => {
  const auth = await getAuthentication();

  const conditions = [
    where('roles.all', 'array-contains', auth.currentUser?.uid),
  ];

  return query(
    getCollection(CollectionOptions.Lifescans).withConverter(lifescanConverter),
    ...conditions,
    orderBy('createdAt', 'desc'),
  );
};
